Object.defineProperty(exports, "__esModule", { value: true });
var Sum = /** @class */ (function () {
    function Sum() {
    }
    /**
     * Returns the sum of all numbers.
     *
     * @returns {number}
     */
    Sum.prototype.sum = function () {
        var result = 0;
        for (var item = this.iterator.next(); !item.done; item = this.iterator.next()) {
            result += item.value;
        }
        return result;
    };
    return Sum;
}());
exports.Sum = Sum;
//# sourceMappingURL=sum.js.map